import { Entity } from "./Entity";
import { BaseApiModel } from "./common/BaseApiModel";

export enum WalletRefundStatus {
  REQUESTED = 'requested',
  REFUNDED = 'refunded',
  REJECTED = 'rejected',
}

export class WalletRefund extends BaseApiModel {
  entity_id?: number;
  entity?: Entity;
  amount?: number;
  status?: WalletRefundStatus;
  iban?: string;
  iban_holder?: string;
  fiscal_code?: string;
  vat?: string;
  business_name?: string;
  business_address?: string;
  business_city_id?: number;
  business_city_name?: string;
  business_province?: string;
  business_tel?: string;
  business_note?: string;
  admin_notes?: string;
  processed_at?: Date;
}
